import React from 'react';

export default function PopupLoading({ show }) {
	if (!show) return null;
	return (
		<div
			style={{
				position: 'fixed',
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				background: 'rgba(0, 0, 0, 0.3)',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				zIndex: 1000
			}}>
			<div
				style={{
					padding: 40,
					background: '#fff',
					borderRadius: 8,
					boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
					textAlign: 'center'
				}}>
				<div
					style={{
						border: '6px solid #eee',
						borderTop: '6px solid #3498db',
						borderRadius: '50%',
						width: 40,
						height: 40,
						margin: 'auto',
						animation: 'spin 1s linear infinite'
					}}
				/>
				<p style={{ marginTop: 16, fontWeight: '600' }}>Loading, please wait...</p>
				<style>{`
                @keyframes spin { 
                    0% { transform: rotate(0deg); } 
                    100% { transform: rotate(360deg); }
                }
                `}</style>
			</div>
		</div>
	);
}
